import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import confetti from 'canvas-confetti'
import { ButtonModule } from 'primeng/button';
import { ApiService } from '../api.service';
import { PanelModule } from 'primeng/panel';
import { UtilsService } from '../utils.service';
import { LocalData, Training, Transaction } from '../app.types';
import { ModalController, IonButton, IonLabel, IonNav, AlertController, NavController } from '@ionic/angular/standalone';
import { AuthService, TempoUser } from '../auth.service';
import { Subscription } from 'rxjs';
import { ExtraptPage } from '../extrapt/extrapt.page';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { Capacitor } from '@capacitor/core';
import { AppstorePage } from '../appstore/appstore.page';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AuthFieldsPage } from '../auth-nav/auth-fields/auth-fields.page';

@Component({
  selector: 'app-confetti',
  imports: [IonLabel, IonButton,
    CommonModule,
    FormsModule,
    ButtonModule,
    PanelModule,
    IonButton,
    MessageModule
  ],
  templateUrl: './confetti.component.html',
  styleUrl: './confetti.component.scss',
  standalone: true
})
export class ConfettiComponent implements OnInit {

  private utils = inject(UtilsService)
  private api = inject(ApiService)
  private auth = inject(AuthService)
  
  @Input() user: TempoUser

  regexReplace: RegExp = new RegExp(/[^0-9\/]/g)
  regex: RegExp = new RegExp(/^\d{1,2}\/?\d{0,2}\/?\d{0,4}$/g)

  saving = false
  formError = false

  @Input() t: Training
  ready = false
  correct = 0
  ptPrize = 0
  extraPrize = 0

  coins = confetti.shapeFromPath({ path: "M20,50 A30,30 0 1,1 80,50 A30,30 0 1,1 20,50 M25,50 A25,25 0 1,1 75,50 A25,25 0 1,1 25,50" })
  canRetry = false

  constructor(
    private modalController: ModalController,
    private nav: IonNav,
    private alertController: AlertController,
    //private changeDetector: ChangeDetectorRef,
    private navController: NavController
  ) { }

  again() {

    confetti({
      spread: 120,
      shapes: [this.coins],
      scalar: 3,
      colors: ["#FFD700", "#FFA500", "#FFFF00"]
    })
  }

  async ngOnInit() {

    console.log("confetti ngOnInit...")

    if (this.t.company_training && (this.t.company_training_prize > 0) && Capacitor.isNativePlatform()) {
      const modal = await this.modalController.create({
        component: ExtraptPage,
        canDismiss: false,
        componentProps: {
          t: this.t
        }
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data) {
        this.extraPrize = this.t.company_training_prize
      }
    }




    
    this.checkScore()
  }

  async checkScore() {
    const ld = await this.utils.getLocalData(this.t, this.user?.uid)
    console.log("checkScore", JSON.stringify(ld,null,2))
    for (const q of this.t.questions!) {
      for (const r of q.responses!) {
        const ur = ld.userData.responses.filter((urf) => urf.rid === r.rid!)
        if (ur.length > 0 && r.correct) {
          this.correct += 1
        }
      }
    }

    this.ptPrize = this.t.single_quest_score! * this.correct + this.extraPrize
    ld.prize = this.ptPrize
    ld.extraPrize = this.extraPrize

    const totprize = this.t.single_quest_score * this.t.questions.length + this.extraPrize
    if (totprize != this.ptPrize) {
      this.canRetry = true
    }

    await this.utils.saveLocalData(this.t.tid, this.user?.uid, ld)
    //ld.quizCompleted = true

    this.api.getMyIpData().then((location) => {
      ld.location = location
      this.utils.saveLocalData(this.t.tid!, this.user.uid, ld)
    }).catch((err) => {
      console.log("getMyIp", err)
      this.utils.saveLocalData(this.t.tid!, this.user.uid, ld)
    })

    setTimeout(() => {
      if (this.correct > 0) this.again()
      this.ready = true
      //this.changeDetector.detectChanges()
    }, 2000);


  }

  async goBack() {
    const ld = await this.utils.getLocalData(this.t, this.user?.uid)
    if(this.t.race_active) {
      ld.quizTimeEnd = undefined
      await this.utils.saveLocalData(this.t.tid, this.user?.uid, ld)
    }
    
    this.nav.popToRoot()
  }

  async transferAsset(ld: LocalData) {
    // TODO upgrade to pt transfer
    // await this.api.transferAsset(this.api.algoUser.address, amount, "Accredito di avvenuta formazione", this.t.address)

    //const ts = await this.api.getTrainingStatus(this.t.tid)



    const ptt = {
      amount: this.ptPrize,
      gid: this.t.gid,
      tid: this.t.tid,
      uid: this.user.uid,
      info: "Accredito di avvenuta formazione '" + this.t.title + "'",
      data: JSON.stringify(ld, null, 2),
      location: JSON.stringify(ld.location, null, 2)
    } as Transaction

    await this.api.ptTransaction(ptt)
    await this.api.saveTrainingUserData(this.user.uid, this.t.tid!, ld.userData.responses)
    ld.accepted = true
    this.utils.saveLocalData(this.t.tid, this.user.uid, ld)
    // this.nav.push(TrainingResultPage, {
    //   result: result,
    //   t: this.t
    // })
  }

  async done() {

    const ld = await this.utils.getLocalData(this.t, this.user?.uid)

    if (ld.accepted) {
      const alert = await this.alertController.create({
        message: "Hai già finalizzato questo contenuto e incassato i PT.",
        buttons: [
          {
            text: "Torna all Home"
          }
        ]
      })
      await alert.present()
      await alert.onDidDismiss()
      await this.modalController.dismiss()
      
    } else {

      const upr = await this.auth.getUserPrivacy(this.user.uid, this.user.selectedGroup.gid)
      const ugdr = await this.auth.getUserGroupData(this.user.uid, this.user.selectedGroup.gid)
      const gdr = await this.auth.getGroupFields(this.user.selectedGroup.gid)

      if(this.user.selectedGroup.consents_rule && (!ugdr.result || ugdr.result.data.groupFields.length === 0) && gdr.groupFields.length > 0) {
        const modal = await this.modalController.create({
          component: AuthFieldsPage,
          componentProps: {
            userPrivacy: upr.result,
            groupFields: gdr.groupFields,
            group: this.user.selectedGroup,
            firebaseUid: this.user.uid,
            fromMenu: true
          }
        })
        modal.present()
        const { data } = await modal.onDidDismiss()
        if (!data) {
          const alert = await this.alertController.create({
            message: "Devi accettare i consensi per finalizzare il contenuto e incassare i PT.",
            buttons: [
              {
                text: "Riprova",
                handler: () => {
                  this.done()
                }
              },
              {
                text: "Annulla", 
                handler: () => {
                  this.modalController.dismiss()
                }
              }
            ]
          })
          await alert.present()
          await alert.onDidDismiss()
          return
        }
      }
      
      await this.transferAsset(ld)
      console.log("transfer done", JSON.stringify(ld, null, 2))
      ld.accepted = true
      ld.quizCompleted = true
      await this.utils.saveLocalData(this.t.tid, this.user.uid, ld)

      if (Capacitor.isNativePlatform()) {
        console.log("Dismissing modal from confetti")
        await this.modalController.dismiss({ home: true })
        this.navController.navigateRoot("/", {onSameUrlNavigation:"reload"})
        //this.auth.updateUser() ????
        this.auth.updateUser()
      } else {
        const fp = await this.auth.generateFingerprint()
        await this.api.createFingerprintToken(this.user.uid, "embedPage", fp)
        await this.modalController.dismiss()
        this.navController.navigateRoot("appstore")
      }

    }

  }

}
